module.exports = "<div class=\"main-container\">\n  <!-- To get all libraries property, search online 'ng2-pdfjs-viewer'-->\n  <ng2-pdfjs-viewer [pdfSrc]=\"pdfSource\" viewerId=\"inline\" #inlinePdfViewer [print]=\"false\" [fullScreen]=\"true\"\n    [find]=\"false\" [openFile]=\"false\" [viewBookmark]=\"false\">\n\n  </ng2-pdfjs-viewer>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/alg-pdf-modal/alg-pdf-modal.component.html
// module id = ./src/app/components/dialogs/alg-pdf-modal/alg-pdf-modal.component.html
// module chunks = main